import React from "react";
// import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import classNames from "classnames";
import { Link, useParams } from "react-router-dom";

import messages from "./messages";
import updatesMessages from "../course-home/updates-tab/messages";
import Tabs from "../generic/tabs/Tabs";
import {
  CoursewareSearch,
  CoursewareSearchToggle,
} from "../course-home/courseware-search";
import { useCoursewareSearchState } from "../course-home/courseware-search/hooks";
// import { useModel } from '../generic/model-store';

const CourseTabsNavigation = ({ activeTabSlug, className, tabs, intl }) => {
  const { show } = useCoursewareSearchState();
  const { courseId } = useParams();
  // const { courseId } = useSelector(state => state.courseHome);
  // const {
  //   title
  // } = useModel('courseHomeMeta', courseId);

  // Helper function to determine if a tab should use React Router Link
  const isInternalTab = (slug) =>
    slug && (slug.startsWith("static_tab_") || slug === "updates" || slug === "survey");

  // Helper function to get the internal route for a client-side tab
  const getInternalTabRoute = (slug) => {
    const tabId = slug.replace("static_tab_", "");
    if (slug === "updates") {
      return `/course/${courseId}/updates`;
    }
    if (slug === "survey") {
      return `/course/${courseId}/survey`;
    }
    return `/course/${courseId}/static-tab/${tabId}`;
  };

  return (
    <div
      id="courseTabsNavigation"
      className={classNames("course-tabs-navigation", className)}
    >
      <div className="container-xl">
        <div className="nav-bar">
          {/* <h1 className='course-title'>{title}</h1> */}
          <div className="nav-menu">
            <Tabs
              className="nav-underline-tabs"
              aria-label={intl.formatMessage(messages.courseMaterial)}
            >
              {tabs.map(({ url, title, slug }) => {
                const isInternal = isInternalTab(slug);
                // Use translated title for "updates" tab, otherwise use the title from props
                const displayTitle = slug === "updates"
                  ? intl.formatMessage(updatesMessages.title)
                  : title;
                const linkProps = {
                  key: slug,
                  className: classNames("nav-item flex-shrink-0 nav-link", {
                    active: slug === activeTabSlug,
                  }),
                };

                if (isInternal) {
                  // Use React Router Link for local tabs to stay in the MFE
                  return (
                    <Link {...linkProps} to={getInternalTabRoute(slug)} id={slug}>
                      {displayTitle}
                    </Link>
                  );
                }

                // Use regular anchor tag for other tabs
                return (
                  <a {...linkProps} href={url} id={slug}>
                    {displayTitle}
                  </a>
                );
              })}
            </Tabs>
          </div>
          <div className="search-toggle">
            <CoursewareSearchToggle />
          </div>
        </div>
      </div>
      {show && <CoursewareSearch />}
    </div>
  );
};

CourseTabsNavigation.propTypes = {
  activeTabSlug: PropTypes.string,
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  intl: intlShape.isRequired,
};

CourseTabsNavigation.defaultProps = {
  activeTabSlug: undefined,
  className: null,
};

export default injectIntl(CourseTabsNavigation);
